// English translations
const en = {
  // Common
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    next: "Next",
    previous: "Previous",
    back: "Back",
    home: "Home",
    dashboard: "Dashboard",
    upgrade: "Upgrade",
    viewPlans: "View Plans",
    logOut: "Log out",
    contactUs: "Contact Us",
    managePlan: "Manage Plan",
    settings: "Settings",
    account: "Account",
    language: "Language",
    english: "English",
    french: "Français"
  },

  // Navigation
  nav: {
    plan: "Plan",
    learn: "Learn",
    practice: "Practice",
    finalReadiness: "Final Readiness",
    account: "Account",
    dashboard: "Dashboard",
    journeyTracker: "Journey Tracker",
    studyPlanner: "Study Planner",
    discoverCanada: "Discover Canada",
    studyGuide: "Study Guide",
    flashcards: "Flashcards",
    weakAreas: "Weak Areas",
    chapterPractice: "Chapter Practice",
    simulations: "Simulations",
    mockTests: "Mock Tests",
    analytics: "Analytics",
    progressSummary: "Progress Summary"
  },

  // Auth
  auth: {
    welcomeBack: "Welcome back",
    signIn: "Sign In",
    signUp: "Sign up",
    createAccount: "Create your account",
    continueWithGoogle: "Continue with Google",
    orContinueWithEmail: "Or continue with email",
    email: "Email",
    password: "Password",
    fullName: "Full Name",
    language: "Language",
    english: "English",
    french: "French",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    signInToContinue: "Sign in to continue your citizenship prep",
    startJourney: "Start your Canadian citizenship journey today",
    selectLanguage: "Select your preferred language"
  },

  // Dashboard
  dashboard: {
    welcomeBack: "Welcome back",
    readyToStart: "Ready to start your Canadian citizenship journey?",
    startPractice: "Start Practice",
    dayStreak: "day streak",
    longest: "Longest",
    total: "Total",
    studyDays: "study days",
    logTodaysStudy: "Log Today's Study",
    testsTaken: "Tests Taken",
    testsPassed: "Tests Passed",
    averageScore: "Average Score",
    studyStreak: "Study Streak",
    quickActions: "Quick Actions",
    recentTests: "Recent Tests",
    viewAll: "View all",
    yourProgress: "Your Progress",
    overallReadiness: "Overall Readiness"
  },

  // Landing Page
  landing: {
    heroTitle: "Pass your Canadian Citizenship Test on the first try.",
    heroSubtitle: "Guaranteed.",
    heroDescription: "Your complete toolkit for success: Prepare with 500+ test questions, simulation tests, chapter practice, flashcards and all the important tools you need.",
    getStarted: "Get Started",
    learnMore: "Learn More",
    howItWorks: "How It Works",
    features: "Features",
    reviews: "Reviews",
    pricing: "Pricing",
    passRate: "Chapters Covered",
    usersPassed: "Users Passed",
    practiceQuestions: "Practice Questions",
    whyChooseUs: "Why Choose CanadaTestPrep?",
    testimonials: "What Our Users Say",
    faq: "Frequently Asked Questions",
    readyToPass: "Ready to Pass Your Test?",
    joinUsers: "Join 1,500+ new Canadians who passed with CanadaTestPrep",
    unlockQuestions: "Unlock all 500+ questions",
    bePartOf: "Be part of the",
    newCitizens: "new citizens who've aced their tests with us.",
    navLogIn: "Log in",
    navDashboard: "Dashboard",
    excellent: "Excellent",
    basedOnReviews: "Based on 200+ reviews",
    keyBenefits: {
      questions: "Over 500+ questions seen on exam",
      studyGuide: "Official Study Guide & Lessons",
      simulator: "Real Test Simulator (Gov't format)",
      aiTools: "Smart study tools & weak area detection",
      guarantee: "Pass Guarantee: pass, or it's on us"
    },
    stats: {
      usersPassed: "Users Passed",
      testQuestions: "Test Questions",
      passRate: "Chapters Covered",
      userRating: "User Rating"
    },
    comparison: {
      nervousTitle: "Nervous about your upcoming exam?",
      funWay: "Say hello to a fun and intuitive way to prepare",
      funDescription: "It's 2026: why settle for outdated methods? We've packed all the tools into an engaging program, engineered to build your confidence one question at a time.",
      oldWay: "Stand-alone Book",
      newWay: "CanadaTestPrep Premium",
      highFailure: "High Failure Rate",
      passRateBadge: "High Pass Rate"
    },
    guarantee: {
      title: "Pass Guarantee: Pass your test, or your money back",
      description: "Even if you've failed before and taking tests makes your hands sweat, with CanadaTestPrep Premium, you're 100% guaranteed to pass. Complete our program and don't pass? We'll refund you in full."
    },
    howItWorksSection: {
      title: "Be fully prepared for your citizenship test",
      description: "Our course is fully online and designed to work with your busy schedule, not the other way around.",
      step1Title: "Start with the Study Guide",
      step1Desc: "Learn chapter by chapter with our comprehensive guide covering all 11 chapters of Discover Canada.",
      step2Title: "Practice with Questions",
      step2Desc: "Test your knowledge with 500+ chapter-wise practice questions and instant feedback.",
      step3Title: "Take Simulation Tests",
      step3Desc: "Experience the real test format with our Government of Canada-style simulator.",
      step4Title: "Pass Your Exam",
      step4Desc: "Walk into your test confident and prepared. Our comprehensive practice tools help you walk in prepared and confident."
    },
    featuresSection: {
      title: "Everything You Need to Pass",
      description: "Comprehensive tools designed to help you master the Canadian Citizenship Test",
      feature1: "500+ Practice Questions",
      feature1Desc: "Comprehensive question bank covering all 11 chapters with detailed explanations.",
      feature2: "200+ Flashcards",
      feature2Desc: "Master key facts, dates, and personalities with interactive flashcards.",
      feature3: "Real Test Simulator",
      feature3Desc: "Experience the exact Government of Canada test interface before exam day.",
      feature4: "Smart Study Planner",
      feature4Desc: "Get a personalized day-by-day study schedule based on your test date.",
      feature5: "Weak Area Detection",
      feature5Desc: "Smart analysis identifies which chapters need more focus based on your test results.",
      feature6: "Important Compilations",
      feature6Desc: "All Important Dates, Key Personalities, and summaries in one place.",
      feature7: "Journey Tracker",
      feature7Desc: "Understand every stage from application to oath ceremony.",
      feature8: "Study Streaks",
      feature8Desc: "Build consistent habits with daily streaks and achievements."
    },
    testimonialsSection: {
      title: "\"These questions were identical to my real test\"",
      description: "Nothing's worse than encountering a question you've never seen. CanadaTestPrep ensures you've seen them all.",
      fromActualUsers: "FROM ACTUAL TEST-TAKERS"
    },
    pricingSection: {
      title: "Let us help you breeze through your test",
      description: "Simple pricing, no hidden fees. One-time purchase, not a subscription.",
      simplePricing: "SIMPLE PRICING"
    },
    ctaSection: {
      title: "When you absolutely need to pass your citizenship test",
      description: "You have zero time and a million responsibilities. If you're going to study, you need to be sure you'll pass on the first try.",
      soYouCanGetBack: "So you can get back to your life."
    },
    footer: {
      madeWithLove: "Made with love in Canada",
      tagline: "The #1 Canadian Citizenship Test Prep Platform"
    }
  },

  // Study
  study: {
    studyGuide: "Study Guide",
    masterChapters: "Master each chapter with summaries, key points, and important dates",
    chapters: "Chapters",
    dates: "Dates",
    people: "People",
    importantDates: "Important Dates",
    keyHistoricalDates: "Key historical dates for the citizenship test",
    importantPersonalities: "Important Personalities",
    keyFigures: "Key historical figures you should know",
    chapterSummary: "Chapter Summary",
    content: "Content",
    keyPoints: "Key Points",
    studyTips: "Study Tips"
  },

  // Flashcards
  flashcards: {
    title: "Flashcards",
    subtitle: "Master key facts with interactive flashcards",
    flipCard: "Flip Card",
    showAnswer: "Show Answer",
    hideAnswer: "Hide Answer",
    nextCard: "Next Card",
    prevCard: "Previous Card",
    cardOf: "Card {current} of {total}"
  },

  // Tests
  tests: {
    startTest: "Start Test",
    submitTest: "Submit Test",
    confirmSubmission: "Confirm Submission",
    timeRemaining: "Time Remaining",
    questionOf: "Question {current} of {total}",
    reviewLater: "I want to review this answer later",
    unansweredWarning: "You have {count} unanswered questions. Are you sure you want to submit?",
    testComplete: "Test Complete",
    yourScore: "Your Score",
    passed: "Passed",
    failed: "Failed",
    reviewAnswers: "Review Answers",
    tryAgain: "Try Again",
    backToTests: "Back to Tests"
  },

  // Contact
  contact: {
    title: "Contact Us",
    subtitle: "Have questions or feedback? We'd love to hear from you.",
    sendMessage: "Send us a Message",
    yourName: "Your Name",
    emailAddress: "Email Address",
    subject: "Subject",
    message: "Message",
    send: "Send Message",
    sending: "Sending...",
    successTitle: "Message Sent!",
    successMessage: "Thank you for reaching out. We've received your message and will get back to you as soon as possible.",
    responseTime: "Response Time",
    responseInfo: "We typically respond within 24-48 hours. For urgent matters, please include \"URGENT\" in your subject line."
  },

  // Pricing
  pricing: {
    title: "Choose Your Plan",
    subtitle: "Start free, upgrade when you're ready",
    free: "Free",
    pro: "Pro",
    premium: "Premium",
    perWeek: "/week",
    lifetime: "Lifetime",
    currentPlan: "Current Plan",
    choosePlan: "Choose Plan",
    mostPopular: "Most Popular",
    bestValue: "Best Value"
  },

  // Discover Canada
  discoverCanada: {
    title: "Discover Canada",
    subtitle: "The official study guide for the Canadian Citizenship Test",
    officialGuide: "Discover Canada: The Rights and Responsibilities of Citizenship",
    guideDescription: "This is the official study guide published by the Government of Canada. It contains all the information you need to know for the citizenship test, including Canadian history, government, rights, and responsibilities.",
    readOnline: "Read Online",
    downloadPdf: "Download PDF",
    whatsInside: "What's Inside"
  },

  // Account Settings
  account: {
    title: "Account Settings",
    personalInfo: "Personal Information",
    email: "Email",
    name: "Name",
    subscription: "Subscription",
    languagePreference: "Language Preference",
    languageDescription: "Choose your preferred language for the application",
    dangerZone: "Danger Zone",
    resetProgress: "Reset All Progress",
    resetDescription: "This will permanently delete all your test history, scores, notes, journey progress, and study streaks. Your account will remain active.",
    resetConfirmTitle: "Are you absolutely sure?",
    resetConfirmDescription: "This action cannot be undone. All your progress data will be permanently deleted.",
    resetButton: "Reset My Progress",
    resetting: "Resetting...",
    resetSuccess: "Progress reset successfully! You can start fresh.",
    typeToConfirm: "Type RESET to confirm"
  },

  // Admin Dashboard
  admin: {
    title: "Admin Dashboard",
    overview: "Overview",
    totalUsers: "Total Users",
    newThisWeek: "New This Week",
    totalRevenue: "Total Revenue",
    totalContacts: "Contact Inquiries",
    subscriptions: "Subscriptions",
    freeUsers: "Free Users",
    proUsers: "Pro Subscribers",
    premiumUsers: "Premium Subscribers",
    languageStats: "Language Preferences",
    englishUsers: "English Users",
    frenchUsers: "French Users",
    recentUsers: "Recent Users",
    contactSubmissions: "Contact Submissions",
    markAsRead: "Mark as Read",
    markAsReplied: "Mark as Replied",
    resolve: "Resolve",
    status: "Status",
    newContact: "New",
    readContact: "Read",
    repliedContact: "Replied",
    resolvedContact: "Resolved"
  }
};

export default en;
